//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SVGLoader from '../global/SVGLoader.vue';
import SearchResultsText from '../SearchResultsText.vue';

export default {
  components: {
    SVGLoader,
    SearchResultsText,
  },
  computed: {
    searchResults: function () {
      if (!this.$root.devData) return this.$store.state.results.itemResults;

      return this.$store.state.results.itemResults.map((result, i) => {
        return {
          ...result,
          meta: {
            ...result.meta,
            award: i < 2 ? 'Gold Production' : i === 2 ? 'Silver Production' : i === 3 ? 'Bronze Production' : null,
            advisor: i == 0,
          },
        };
      });
    },
    settings: function () {
      return this.$store.state.settings;
    },
  },
  methods: {
    getAriaText: function (item) {
      if (item != null) {
        return 'Click to go to ' + item.title;
      } else {
        return '';
      }
    },
  },
};
